const bloggers = {
  init: function (id, searchStatus) {
    this.modalBlock = document.getElementById(id);
    this.listeners(searchStatus);
    this.iframe = document.getElementById('link');
  },
  listeners: function (recursiv) {
    if (this.modalBlock) {
      this.modalBlock.addEventListener("click", (e) => {
        const target = e.target,
          nodes = recursiv ? [target, target.parentNode.parentNode, target.parentNode.parentNode.parentNode] : [target, target.parentNode];
        this.searchParams(nodes);
      });
    } else {
      log('js-modalBloggers undefined');
    }
  },
  searchParams: function (targets) {
    targets.forEach(e => {
      if (e.dataset.target) {
        this.updateIframe(e.dataset.mlink);
      }
    });
  },
  updateIframe: function (link) {
   this.iframe.src = link;
  },
  clear: function () {
    this.iframe.src = '';
  }
}

module.exports = bloggers;